export default [
  {
    path: '/introduce',
    name: 'introduce',
    component: resolve => require(['/src/views/companyIntroduce/index.vue'], resolve),
    meta: { title: '企业介绍', isToken: false, isNeedHeader: true }
  },
]